var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","color":"white","clas":"pt-3"}},[_c('h2',{staticClass:"grey--text px-2 py-2"},[_vm._v(_vm._s(_vm.contact.name+ ' '+ _vm.contact.surname))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }